import styled, { createGlobalStyle, keyframes } from 'styled-components';
import { 
  FaShoppingCart, 
  FaExclamationCircle, 
  FaTimesCircle, 
  FaShieldAlt, 
  FaChartLine, 
  FaClock, 
  FaExclamationTriangle, 
  FaSortAmountDown, 
  FaHourglassHalf, 
  FaHandHoldingUsd, 
  FaUsers, 
  FaTachometerAlt, 
  FaBullseye,
  FaRocket, 
  FaRobot, 
  FaCode, 
  FaBrain, 
  FaStar, 
  FaCheckCircle,
  FaLink,
  FaCheck,
  FaProjectDiagram,
  FaBolt,
  FaChartBar,
  FaDollarSign,
  FaCheckDouble,
  FaLightbulb,
  FaSearch,
  FaPencilRuler,
  FaVial,
  FaSyncAlt,
  FaTasks,
  FaBox,
  FaCogs,
  FaPiggyBank,
  FaExpandArrowsAlt,
  FaSmile,
  FaGift,
  FaHandshake,
  FaClipboardCheck,
  FaArrowRight,
  FaComments,
  FaFileContract,
  FaCalendarCheck
} from 'react-icons/fa';

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

  body {
    
  }
`;

export const PageWrapper = styled.div`
  --vidal-primary: #22c55e;
  --vidal-secondary: #16a34a;
  --vidal-accent: #15803d;
  --vidal-purple: #8b5cf6;
  --vidal-purple-light: #a78bfa;
  --vidal-purple-dark: #7c3aed;
  --vidal-blue: #3b82f6;
  --vidal-cyan: #06b6d4;
  --vidal-orange: #f59e0b;
  --bg-primary: #1f2937;
  --bg-secondary: #111827;
  --bg-tertiary: #374151;
  --bg-card: rgba(31, 41, 55, 0.8);
  --text-primary: #ffffff;
  --text-secondary: #d1d5db;
  --text-muted: #9ca3af;
  --border-color: rgba(255, 255, 255, 0.1);
  --border-green: rgba(34, 197, 94, 0.2);
  --border-purple: rgba(139, 92, 246, 0.2);
  --shadow-green: rgba(34, 197, 94, 0.3);
  --shadow-purple: rgba(139, 92, 246, 0.3);

  background: var(--bg-primary);
  color: var(--text-primary);
  line-height: 1.6;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  font-family: 'Inter', sans-serif;
`;

export const Navbar = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 9999;
  background: linear-gradient(
    135deg,
    rgba(26, 22, 37, 0.95) 0%,
    rgba(15, 13, 26, 0.9) 100%
  );
  backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--border-color);
  box-shadow: 0 4px 24px rgba(139, 92, 246, 0.1);
  transition: all 0.3s ease;
`;

export const NavbarContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;

  @media (max-width: 768px) {
    padding: 12px 16px;
    height: 60px;
  }
`;

export const NavbarBrand = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  flex-shrink: 0;
  transition: all 0.3s ease;
  color: var(--text-primary);
  font-weight: 700;
  font-size: 1.2rem;
  gap: 10px;

  &:hover {
    transform: translateY(-1px);
  }

  img {
    height: 36px;
    width: auto;
    object-fit: contain;
    filter: drop-shadow(0 2px 8px rgba(34, 197, 94, 0.3));
    
    @media (max-width: 768px) {
      height: 32px;
    }
  }
`;

export const NavbarNav = styled.ul`
  display: flex;
  align-items: center;
  gap: 32px;
  list-style: none;

  @media (max-width: 1330px) {
    position: fixed;
    top: 70px;
    right: ${({ $active }) => ($active ? '0' : '-100%')};
    width: 280px;
    height: calc(100vh - 70px);
    background: linear-gradient(
      135deg,
      rgba(17, 24, 39, 0.98) 0%,
      rgba(31, 41, 55, 0.95) 100%
    );
    backdrop-filter: blur(20px);
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    padding: 20px;
    gap: 0;
    box-shadow: -5px 0 20px rgba(0, 0, 0, 0.3);
    transition: right 0.3s ease;
    z-index: 9998;
  }

  @media (max-width: 768px) {
    top: 60px;
    height: calc(100vh - 60px);
  }
`;

export const NavLink = styled.a`
  color: var(--text-secondary);
  text-decoration: none;
  font-weight: 500;
  font-size: 15px;
  padding: 12px 20px;
  border-radius: 12px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  
  &::before {
    content: "";
    position: absolute;
    bottom: 8px;
    left: 20px;
    right: 20px;
    height: 2px;
    background: linear-gradient(
      90deg,
      var(--vidal-primary),
      var(--vidal-purple)
    );
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }

  &:hover {
    color: var(--vidal-primary);
    background: rgba(34, 197, 94, 0.08);
  }

  &:hover::before {
    transform: scaleX(1);
  }

  svg {
    font-size: 14px;
    opacity: 0.8;
  }

  @media (max-width: 1330px) {
    width: 100%;
    padding: 16px 20px;
    font-size: 16px;
    border-radius: 0;
    justify-content: flex-start;

    &:hover {
      background: rgba(255, 255, 255, 0.08);
      transform: translateX(4px);
    }
  }
`;

export const NavCta = styled.a`
  background: linear-gradient(
    135deg,
    var(--vidal-primary) 0%,
    var(--vidal-secondary) 100%
  );
  color: white !important;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px var(--shadow-green);
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  overflow: hidden;

  svg {
    font-size: 14px; /* Ensure icon size matches */
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    transition: left 0.5s ease;
  }

  &:hover::before {
    left: 100%;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 28px var(--shadow-green);
    color: white !important;
  }

  @media (max-width: 1330px) {
    margin-top: 16px;
    border-radius: 12px;
  }
`;

export const NavbarToggle = styled.div`
  display: none;
  cursor: pointer;
  padding: 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: 44px;
  height: 44px;
  position: relative;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
  }

  span {
    width: 20px;
    height: 2px;
    background: #e5e7eb;
    position: absolute;
    left: 50%;
    top: 50%;
    transition: all 0.3s ease;
    border-radius: 1px;
  }

  span:nth-child(1) {
    transform: translate(-50%, -50%) translateY(-6px);
  }
  span:nth-child(2) {
    transform: translate(-50%, -50%);
  }
  span:nth-child(3) {
    transform: translate(-50%, -50%) translateY(6px);
  }

  ${({ $active }) => $active && `
    span:nth-child(1) {
      transform: translate(-50%, -50%) rotate(45deg);
    }
    span:nth-child(2) {
      opacity: 0;
    }
    span:nth-child(3) {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  `}

  @media (max-width: 1330px) {
    display: flex;
  }
`;

export const HeroSection = styled.section`
  padding: 120px 0 80px;
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: linear-gradient(
    135deg,
    var(--bg-primary) 0%,
    var(--bg-secondary) 50%,
    var(--bg-primary) 100%
  );

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(
        circle at 30% 20%,
        rgba(34, 197, 94, 0.06) 0%,
        transparent 60%
      ),
      radial-gradient(
        circle at 80% 70%,
        rgba(139, 92, 246, 0.08) 0%,
        transparent 60%
      );
    pointer-events: none;
  }
`;

export const Container = styled.div`
  max-width: 55%;
  margin: 0 auto;
  padding: 0 40px;
  position: relative;

  @media (max-width: 1400px) {
    max-width: 70%;
  }
  @media (max-width: 1024px) {
    max-width: 85%;
  }
  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0 20px;
  }
  @media (max-width: 480px) {
    padding: 0 16px;
  }
`;

export const HeroContent = styled.div`
  max-width: 900px;
  text-align: left;
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.1);
  }
`;

export const HeroBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(34, 197, 94, 0.1);
  color: var(--vidal-primary);
  padding: 8px 16px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgba(34, 197, 94, 0.3);
  margin-bottom: 24px;

  .pulse {
    width: 8px;
    height: 8px;
    background: var(--vidal-primary);
    border-radius: 50%;
    animation: ${pulse} 2s infinite;
  }
`;

export const HeroTitle = styled.h1`
  font-size: 3.5rem;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 24px;
  color: var(--text-primary);

  span.highlight {
    background: linear-gradient(
      135deg,
      var(--vidal-primary) 0%,
      var(--vidal-secondary) 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const HeroSubtitle = styled.p`
  font-size: 1.25rem;
  color: var(--text-secondary);
  margin-bottom: 32px;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1.125rem;
  }
`;

export const HeroButtons = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 48px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const Button = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 16px 32px;
  border-radius: 12px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 16px;
  border: none;
  cursor: pointer;
  justify-content: center;

  svg {
    // Add margin if it's the right arrow
  }

  ${({ $primary }) => $primary && `
    background: linear-gradient(
      135deg,
      var(--vidal-primary) 0%,
      var(--vidal-secondary) 100%
    );
    color: white;
    box-shadow: 0 4px 12px var(--shadow-green);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 24px var(--shadow-green);
    }
  `}

  ${({ $outline }) => $outline && `
    background: transparent;
    color: var(--text-primary);
    border: 2px solid var(--border-color);

    &:hover {
      border-color: var(--vidal-primary);
      background: rgba(34, 197, 94, 0.1);
      color: var(--vidal-primary);
    }
  `}
`;

export const ProposalData = styled.div`
  margin-top: 64px;
  background: var(--bg-card);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid var(--border-green);
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
`;

export const ProposalDataHeader = styled.div`
  background: linear-gradient(
    90deg,
    var(--vidal-primary) 0%,
    var(--vidal-secondary) 100%
  );
  padding: 3px;
`;

export const ProposalDataContent = styled.div`
  padding: 32px;

  @media (max-width: 480px) {
    padding: 24px;
  }
`;

export const ProposalDataTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 24px;

  svg {
    color: var(--vidal-primary);
  }
`;

export const ProposalDataGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const DataItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DataLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const DataValue = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  background: rgba(34, 197, 94, 0.1);
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid rgba(34, 197, 94, 0.2);
  display: flex;
  align-items: center;
  gap: 8px;
  
  svg {
    color: var(--vidal-primary);
    font-size: 14px;
  }
`;

export const NavbarOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 999;

  /* ... existing styles ... */
  ${({ $active }) => $active && `
    opacity: 1;
    visibility: visible;
  `}
`;

/* Section Styles */
export const Section = styled.section`
  padding: 80px 0;
  position: relative;

  &.section-1 {
    background: linear-gradient(
      135deg,
      rgba(15, 23, 42, 1) 0%,
      rgba(30, 41, 59, 0.98) 100%
    );
  }

  &.section-2 {
    background: linear-gradient(
      135deg,
      rgba(30, 41, 59, 1) 0%,
      rgba(15, 23, 42, 0.98) 100%
    );
  }

  &.section-4 {
    background: linear-gradient(
      135deg,
      rgba(30, 41, 59, 1) 0%,
      rgba(15, 23, 42, 0.98) 100%
    );
  }

  &.section-5 {
    background: linear-gradient(
      135deg,
      rgba(15, 23, 42, 1) 0%,
      rgba(30, 41, 59, 0.98) 100%
    );
  }

  &.section-6 {
    background: linear-gradient(
      135deg,
      rgba(30, 41, 59, 1) 0%,
      rgba(15, 23, 42, 0.98) 100%
    );
  }
`;

export const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SectionBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  border-radius: 50px;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 32px;

  /* Section 1 Badge Style */
  .section-1 & {
    background: linear-gradient(
      135deg,
      rgba(34, 197, 94, 0.15) 0%,
      rgba(22, 163, 74, 0.1) 100%
    );
    border: 2px solid rgba(34, 197, 94, 0.4);
    color: white;
    box-shadow: 0 4px 16px rgba(34, 197, 94, 0.2);

    svg {
      color: var(--vidal-primary);
      font-size: 16px;
    }
  }

  /* Section 2 Badge Style */
  .section-2 & {
    background: linear-gradient(
      135deg,
      rgba(59, 130, 246, 0.15) 0%,
      rgba(37, 99, 235, 0.1) 100%
    );
    border: 2px solid rgba(59, 130, 246, 0.4);
    color: white;
    box-shadow: 0 4px 16px rgba(59, 130, 246, 0.2);

    svg {
      color: var(--vidal-blue);
      font-size: 16px;
    }
  }

  /* Section 4 Badge Style */
  .section-4 & {
    background: linear-gradient(
      135deg,
      rgba(139, 92, 246, 0.15) 0%,
      rgba(124, 58, 237, 0.1) 100%
    );
    border: 2px solid rgba(139, 92, 246, 0.4);
    color: white;
    box-shadow: 0 4px 16px rgba(139, 92, 246, 0.2);

    svg {
      color: var(--vidal-purple);
      font-size: 16px;
    }
  }

  /* Section 5 Badge Style */
  .section-5 & {
    background: linear-gradient(
      135deg,
      rgba(16, 185, 129, 0.15) 0%,
      rgba(5, 150, 105, 0.1) 100%
    );
    border: 2px solid rgba(16, 185, 129, 0.4);
    color: white;
    box-shadow: 0 4px 16px rgba(16, 185, 129, 0.2);

    svg {
      color: var(--vidal-secondary);
      font-size: 16px;
    }
  }

  /* Section 6 Badge Style */
  .section-6 & {
    background: linear-gradient(
      135deg,
      rgba(37, 99, 235, 0.15) 0%,
      rgba(29, 78, 216, 0.1) 100%
    );
    border: 2px solid rgba(37, 99, 235, 0.4);
    color: white;
    box-shadow: 0 4px 16px rgba(37, 99, 235, 0.2);

    svg {
      color: var(--vidal-blue);
      font-size: 16px;
    }
  }
`;

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 800;
  color: white;
  margin-bottom: 16px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  /* Section 1 Title Icon */
  .section-1 & svg {
    color: var(--vidal-primary);
    font-size: 2.25rem;
  }

  /* Section 2 Title Icon */
  .section-2 & svg {
    color: var(--vidal-blue);
    font-size: 2.25rem;
  }

  /* Section 4 Title Icon */
  .section-4 & svg {
    color: var(--vidal-purple);
    font-size: 2.25rem;
  }

  /* Section 5 Title Icon */
  .section-5 & svg {
    color: var(--vidal-secondary);
    font-size: 2.25rem;
  }

  /* Section 6 Title Icon */
  .section-6 & svg {
    color: var(--vidal-blue);
    font-size: 2.25rem;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
    flex-direction: column;
    gap: 8px;
    
    svg {
      font-size: 2rem;
    }
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 1.125rem;
  color: #9ca3af;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
  
  @media (max-width: 768px) {
    font-size: 1.125rem;
  }
`;

/* Content Card */
export const ContentCard = styled.div`
  background: rgba(31, 41, 55, 0.6);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 32px;
  margin-bottom: 48px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(34, 197, 94, 0.2);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  }

  p {
    color: var(--text-secondary);
    line-height: 1.8;
    font-size: 16px;
    margin: 0;

    strong {
      color: var(--text-primary);
      font-weight: 600;
    }
  }
`;

/* Pillars Grid */
export const PillarsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 48px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const PillarCard = styled.div`
  background: rgba(31, 41, 55, 0.6);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 32px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  }

  &.purple {
    border-color: rgba(139, 92, 246, 0.2);
    &:hover { border-color: rgba(139, 92, 246, 0.4); }
  }

  &.blue {
    border-color: rgba(59, 130, 246, 0.2);
    &:hover { border-color: rgba(59, 130, 246, 0.4); }
  }

  &.green {
    border-color: rgba(34, 197, 94, 0.2);
    &:hover { border-color: rgba(34, 197, 94, 0.4); }
  }
`;

export const PillarIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin-bottom: 20px;

  &.purple {
    background: rgba(139, 92, 246, 0.1);
    border: 1px solid rgba(139, 92, 246, 0.2);
    color: #a78bfa;
  }

  &.blue {
    background: rgba(59, 130, 246, 0.1);
    border: 1px solid rgba(59, 130, 246, 0.2);
    color: #60a5fa;
  }

  &.green {
    background: rgba(34, 197, 94, 0.1);
    border: 1px solid rgba(34, 197, 94, 0.2);
    color: #4ade80;
  }
`;

export const PillarTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
  margin-bottom: 12px;
`;

export const PillarDescription = styled.p`
  font-size: 15px;
  color: var(--text-secondary);
  margin-bottom: 20px;
  line-height: 1.6;
`;

export const PillarList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    font-size: 14px;
    color: var(--text-secondary);
    margin-bottom: 8px;
    padding-left: 24px;
    position: relative;
    line-height: 1.6;

    &:last-child { margin-bottom: 0; }

    &::before {
      content: "✓";
      position: absolute;
      left: 0;
      font-weight: 700;
    }
  }

  ${PillarCard}.purple & li::before { color: #a78bfa; }
  ${PillarCard}.blue & li::before { color: #60a5fa; }
  ${PillarCard}.green & li::before { color: #4ade80; }
`;

/* Differentials Box */
export const DifferentialsBox = styled.div`
  background: linear-gradient(
    135deg,
    rgba(34, 197, 94, 0.1) 0%,
    rgba(22, 163, 74, 0.05) 100%
  );
  border-left: 4px solid var(--vidal-primary);
  border-radius: 12px;
  padding: 32px;
  margin-bottom: 48px;

  @media (max-width: 768px) {
    padding: 32px 24px;
  }
`;

export const DifferentialsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;

  svg {
    font-size: 24px;
    color: var(--vidal-primary);
  }

  h3 {
    font-size: 1.5rem;
    font-weight: 700;
    color: white;
    margin: 0;
  }
`;

export const DifferentialsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const DifferentialItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;

  svg {
    color: var(--vidal-primary);
    font-size: 18px;
    margin-top: 2px;
    flex-shrink: 0;
  }

  .differential-content strong {
    color: white;
    font-weight: 600;
    display: block;
    margin-bottom: 4px;
  }

  .differential-content p {
    color: var(--text-secondary);
    font-size: 14px;
    margin: 0;
    line-height: 1.6;
  }
`;

/* Challenge Styles */
export const ChallengeContainer = styled.div`
  margin-bottom: 64px;
  &:last-of-type { margin-bottom: 48px; }
`;

export const ChallengeIntroCard = styled.div`
  background: linear-gradient(
    135deg,
    rgba(59, 130, 246, 0.08) 0%,
    rgba(37, 99, 235, 0.04) 100%
  );
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-left: 4px solid var(--vidal-blue);
  padding: 32px;
  margin-bottom: 24px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(59, 130, 246, 0.15);
    border-color: rgba(59, 130, 246, 0.3);
  }
`;

export const ChallengeIntroHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
`;

export const ChallengeNumber = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: linear-gradient(
    135deg,
    rgba(59, 130, 246, 0.2) 0%,
    rgba(37, 99, 235, 0.1) 100%
  );
  border: 2px solid rgba(59, 130, 246, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 800;
  color: #60a5fa;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
`;

export const ChallengeIntroContent = styled.div`
  flex: 1;

  h3 {
    font-size: 1.5rem;
    font-weight: 700;
    color: white;
    margin: 0 0 8px 0;
    display: flex;
    align-items: center;
    gap: 12px;

    svg {
      color: #60a5fa;
      font-size: 1.25rem;
    }
  }

  p {
    color: var(--text-secondary);
    font-size: 15px;
    line-height: 1.6;
    margin: 0;
  }
`;

export const ChallengeDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ChallengeDetailCard = styled.div`
  background: rgba(31, 41, 55, 0.6);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    border-color: rgba(255, 255, 255, 0.15);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  }

  &.blue { background: rgba(31, 41, 55, 0.6); }

  .challenge-detail-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
  }

  .challenge-detail-icon {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
  }

  &.blue .challenge-detail-icon {
    background: rgba(59, 130, 246, 0.1);
    border-color: rgba(59, 130, 246, 0.2);
    color: #60a5fa;
  }

  &.orange .challenge-detail-icon {
    background: rgba(249, 115, 22, 0.1);
    border-color: rgba(249, 115, 22, 0.2);
    color: #fb923c;
  }

  &.purple .challenge-detail-icon {
    background: rgba(168, 85, 247, 0.1);
    border-color: rgba(168, 85, 247, 0.2);
    color: #a78bfa;
  }

  &.cyan .challenge-detail-icon {
    background: rgba(6, 182, 212, 0.1);
    border-color: rgba(6, 182, 212, 0.2);
    color: #22d3ee;
  }

  h4 {
    font-size: 1rem;
    font-weight: 600;
    color: white;
    margin: 0;
  }
`;


export const ChallengeDetailHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  .challenge-detail-icon {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
  }
`;

export const ChallengeDetailList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    font-size: 14px;
    color: var(--text-secondary);
    margin-bottom: 10px;
    padding-left: 20px;
    position: relative;
    line-height: 1.6;

    &:last-child { margin-bottom: 0; }
    
    &::before {
      content: "→";
      position: absolute;
      left: 0;
      color: #6b7280;
      font-weight: 700;
    }
  }
`;

export const ImpactMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ImpactMetric = styled.div`
  background: rgba(31, 41, 55, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(31, 41, 55, 0.8);
    transform: scale(1.02);
  }

  .impact-metric-icon {
    width: 40px;
    height: 40px;
    margin: 0 auto 12px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    
    background: rgba(239, 68, 68, 0.1);
    border: 1px solid rgba(239, 68, 68, 0.2);
    color: #f87171;
  }

  .impact-metric-label {
    font-size: 12px;
    font-weight: 600;
    color: #f87171;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
  }

  .impact-metric-value {
    font-size: 13px;
    color: var(--text-secondary);
    line-height: 1.4;
  }
`;

export const PotentialBox = styled.div`
  background: linear-gradient(
    135deg,
    rgba(34, 197, 94, 0.1) 0%,
    rgba(6, 182, 212, 0.05) 100%
  );
  border: 1px solid rgba(34, 197, 94, 0.2);
  border-radius: 24px;
  padding: 48px;
  margin-top: 80px;

  @media (max-width: 768px) {
    padding: 32px 24px;
    margin-top: 64px;
  }
`;

export const PotentialHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 48px;
  
  h3 {
    font-size: 2rem;
    font-weight: 700;
    color: white;
    margin: 0;
  }

  svg {
    color: var(--vidal-primary);
    font-size: 2rem;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    h3 { font-size: 1.5rem; }
  }
`;

export const PotentialGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const PotentialCard = styled.div`
  background: var(--bg-card);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 32px;
  text-align: center;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-8px);
    border-color: var(--vidal-primary);
    box-shadow: 0 10px 30px rgba(34, 197, 94, 0.15);
  }

  .potential-card-icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 24px;
    background: linear-gradient(
      135deg,
      rgba(34, 197, 94, 0.2) 0%,
      rgba(34, 197, 94, 0.05) 100%
    );
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: var(--vidal-primary);
    border: 1px solid rgba(34, 197, 94, 0.3);
  }

  .potential-card-label {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-secondary);
    margin-bottom: 8px;
  }

  .potential-card-value {
    font-size: 3rem;
    font-weight: 800;
    color: white;
    margin-bottom: 16px;
    line-height: 1;
    background: linear-gradient(
      135deg,
      #ffffff 0%,
      #e5e7eb 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .potential-card-description {
    font-size: 14px;
    color: var(--text-muted);
    line-height: 1.6;
    margin: 0;
  }
  }
`;

/* Section 3: Solutions */
export const SolutionContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 80px;

  @media (max-width: 768px) {
    gap: 60px;
  }
`;

export const SolutionCard = styled.div `
  background: var(--bg-card);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  padding: 48px;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(
      90deg,
      var(--vidal-primary),
      var(--vidal-secondary)
    );
  }

  /* Variant for second solution */
  &:nth-child(even)::before {
    background: linear-gradient(
      90deg,
      var(--vidal-blue),
      var(--vidal-cyan)
    );
  }

  @media (max-width: 768px) {
    padding: 32px 24px;
  }
`;

export const SolutionHeader = styled.div `
  display: flex;
  gap: 24px;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SolutionIcon = styled.div `
  width: 80px;
  height: 80px;
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.2);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: var(--vidal-primary);
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.2);

  &.blue {
    background: rgba(59, 130, 246, 0.1);
    border-color: rgba(59, 130, 246, 0.2);
    color: var(--vidal-blue);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
  }
`;

export const SolutionHeaderContent = styled.div `
  flex: 1;
`;

export const SolutionBadge = styled.div `
  display: inline-block;
  padding: 6px 16px;
  background: rgba(34, 197, 94, 0.15);
  color: var(--vidal-primary);
  border-radius: 50px;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 12px;
  letter-spacing: 1px;
  border: 1px solid rgba(34, 197, 94, 0.3);

  &.blue {
    background: rgba(59, 130, 246, 0.15);
    color: var(--vidal-blue);
    border-color: rgba(59, 130, 246, 0.3);
  }
`;

export const SolutionTitle = styled.h3 `
  font-size: 2rem;
  font-weight: 700;
  color: white;
  margin: 0;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const SolutionDescription = styled.p `
  font-size: 1.125rem;
  color: var(--text-secondary);
  line-height: 1.8;
  margin-bottom: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const SolutionSectionTitle = styled.h4 `
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;

  svg {
    color: var(--vidal-primary);
  }
`;

export const FunctionalitiesGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 40px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const FunctionalityItem = styled.div `
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.03);
  padding: 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);

  svg {
    color: var(--vidal-primary);
    font-size: 14px;
    flex-shrink: 0;
  }

  span {
    color: var(--text-secondary);
    font-size: 14px;
    font-weight: 500;
  }
`;

export const TechBadges = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 40px;
`;

export const TechBadge = styled.span `
  background: rgba(15, 23, 42, 0.6);
  color: var(--text-secondary);
  padding: 8px 16px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--vidal-primary);
  }
`;

export const BenefitsBox = styled.div `
  background: rgba(15, 23, 42, 0.4);
  border-radius: 16px;
  padding: 32px;
  border: 1px solid rgba(255, 255, 255, 0.05);
`;

export const BenefitsGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const BenefitItem = styled.div `
  display: flex;
  gap: 16px;
`;

export const BenefitIcon = styled.div `
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
  
  /* Dynamic colors handled by child svg or inline style in usage,
     but here we can rely on the icon color itself or specific classes */
`;

export const BenefitContent = styled.div `
  display: flex;
  flex-direction: column;
`;

export const BenefitLabel = styled.div `
  font-size: 15px;
  font-weight: 700;
  color: white;
  margin-bottom: 4px;
`;

export const BenefitDescription = styled.div `
  font-size: 13px;
  color: var(--text-muted);
  line-height: 1.4;
`;

export const AutomationTimeline = styled.div `
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 16px;
  margin-bottom: 40px;
  position: relative;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 32px;
    padding-left: 20px;
    
    &::before {
      content: "";
      position: absolute;
      left: 7px;
      top: 0;
      bottom: 0;
      width: 2px;
      background: rgba(59, 130, 246, 0.2);
    }
  }
`;

export const TimelineItem = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const TimelineNumber = styled.div `
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.3);
  color: var(--vidal-blue);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  z-index: 1;

  @media (max-width: 768px) {
    background: var(--bg-body); /* To hide line behind it */
    flex-shrink: 0;
  }
`;

export const TimelineContent = styled.div `
  flex: 1;
`;

export const TimelineTitle = styled.div `
  font-size: 14px;
  font-weight: 700;
  color: white;
  margin-bottom: 4px;
`;

export const TimelineDescription = styled.div `
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.4;
`;

/* Section 4: Methodology */
export const MethodologyPhases = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 80px;
`;

export const PhaseCard = styled.div`
  background: var(--bg-card);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 32px;
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 40px;
  transition: all 0.3s ease;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  /* Phase Header styling */
  .phase-header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-right: 40px;
    border-right: 1px solid rgba(255, 255, 255, 0.1);

    @media (max-width: 1024px) {
      padding-right: 0;
      border-right: none;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      padding-bottom: 32px;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 20px;
      align-items: flex-start;
    }
  }

  .phase-number {
    font-size: 4rem;
    font-weight: 800;
    line-height: 1;
    opacity: 0.1;
    margin-bottom: 20px;

    @media (max-width: 1024px) {
      margin-bottom: 0;
    }
  }

  .phase-icon-wrapper {
    flex: 1;
  }

  .phase-title-group {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 12px;
  }

  .phase-icon {
    font-size: 24px;
    color: var(--vidal-blue);
  }

  .phase-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: white;
    margin: 0;
  }

  .phase-objective {
    font-size: 14px;
    color: var(--text-secondary);
    line-height: 1.6;
    margin: 0;
  }

  .phase-duration {
    margin-top: 24px;
    display: inline-flex;
    padding: 6px 16px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 50px;
    font-size: 13px;
    font-weight: 600;
    color: var(--text-secondary);
    border: 1px solid rgba(255, 255, 255, 0.1);
    width: fit-content;
  }

  /* Phase Content styling */
  .phase-content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  /* Section (Activities/Deliverables) */
  .phase-section {
    h5 {
      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: 1px;
      margin: 0 0 16px 0;
      color: var(--text-muted);
      display: flex;
      align-items: center;
      gap: 8px;

      svg { color: var(--vidal-primary); }
    }
  }

  .phase-list {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      font-size: 14px;
      color: var(--text-secondary);
      margin-bottom: 10px;
      padding-left: 20px;
      position: relative;
      line-height: 1.6;

      &::before {
        content: "•";
        position: absolute;
        left: 0;
        color: var(--vidal-primary);
        font-weight: bold;
      }
    }
  }

  /* Color Variations */
  &.blue {
    .phase-number { color: var(--vidal-blue); }
    .phase-icon { color: var(--vidal-blue); }
  }
  &.purple {
    .phase-number { color: var(--vidal-purple); }
    .phase-icon { color: var(--vidal-purple); }
  }
  &.green {
    .phase-number { color: var(--vidal-primary); }
    .phase-icon { color: var(--vidal-primary); }
  }
  &.orange {
    .phase-number { color: var(--vidal-orange); }
    .phase-icon { color: var(--vidal-orange); }
  }
  &.cyan {
    .phase-number { color: var(--vidal-cyan); }
    .phase-icon { color: var(--vidal-cyan); }
  }
  &.teal {
    .phase-number { color: #14b8a6; }
    .phase-icon { color: #14b8a6; }
  }
`;

export const MethodologyDifferentials = styled.div`
  background: linear-gradient(
    135deg,
    rgba(59, 130, 246, 0.1) 0%,
    rgba(139, 92, 246, 0.05) 100%
  );
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 24px;
  padding: 40px;

  h3 {
    font-size: 1.5rem;
    font-weight: 700;
    color: white;
    margin: 0 0 32px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;

    svg { color: var(--vidal-orange); }
  }
`;

export const MethodDifferentialsGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const DifferentialItemMethod = styled.div`
  background: rgba(15, 23, 42, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    background: rgba(15, 23, 42, 0.6);
    border-color: rgba(59, 130, 246, 0.3);
  }

  svg {
    font-size: 32px;
    color: var(--vidal-blue);
    margin-bottom: 16px;
  }

  strong {
    display: block;
    font-size: 16px;
    color: white;
    margin-bottom: 8px;
  }

  p {
    font-size: 13px;
    color: var(--text-secondary);
    line-height: 1.5;
    margin: 0;
  }

`;

/* Section 5: Benefits */
export const TangibleBenefits = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin-bottom: 80px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const BenefitCardLarge = styled.div`
  background: var(--bg-card);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 32px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3);
  }

  /* Color variants */
  &.green {
    border-color: rgba(34, 197, 94, 0.3);
    &:hover { box-shadow: 0 12px 24px rgba(34, 197, 94, 0.15); }
  }
  &.blue {
    border-color: rgba(59, 130, 246, 0.3);
    &:hover { box-shadow: 0 12px 24px rgba(59, 130, 246, 0.15); }
  }
  &.purple {
    border-color: rgba(139, 92, 246, 0.3);
    &:hover { box-shadow: 0 12px 24px rgba(139, 92, 246, 0.15); }
  }
`;

export const BenefitCardIconLarge = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  position: relative;
  z-index: 1;

  &.green {
    background: rgba(34, 197, 94, 0.1);
    color: var(--vidal-primary);
    box-shadow: 0 0 20px rgba(34, 197, 94, 0.2);
  }
  &.blue {
    background: rgba(59, 130, 246, 0.1);
    color: var(--vidal-blue);
    box-shadow: 0 0 20px rgba(59, 130, 246, 0.2);
  }
  &.purple {
    background: rgba(139, 92, 246, 0.1);
    color: var(--vidal-purple);
    box-shadow: 0 0 20px rgba(139, 92, 246, 0.2);
  }
`;

export const BenefitCardMetric = styled.div`
  font-size: 3rem;
  font-weight: 800;
  color: white;
  line-height: 1;
  margin-bottom: 12px;
  letter-spacing: -1px;
`;

export const BenefitCardDescription = styled.div `
  font-size: 1.125rem;
  color: var(--text-secondary);
  margin-bottom: 24px;
  font-weight: 500;
`;

export const BenefitCardList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;

  li {
    font-size: 14px;
    color: var(--text-muted);
    margin-bottom: 10px;
    padding-left: 20px;
    position: relative;

    &::before {
      content: "•";
      position: absolute;
      left: 0;
      color: white; /* Will inherit card color ideally, simplified here */
      font-weight: bold;
    }
  }
`;

export const IntangibleBenefits = styled.div`
  margin-bottom: 80px;

  h3 {
    text-align: center;
    font-size: 2rem;
    color: white;
    margin-bottom: 40px;
  }
`;

export const IntangibleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const IntangibleItem = styled.div`
  background: rgba(15, 23, 42, 0.3);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(15, 23, 42, 0.5);
    border-color: rgba(255, 255, 255, 0.1);
    transform: translateY(-4px);
  }

  svg {
    font-size: 24px;
    color: var(--vidal-primary);
    flex-shrink: 0;
    margin-top: 4px;
  }

  strong {
    display: block;
    font-size: 16px;
    color: white;
    margin-bottom: 4px;
  }

  p {
    font-size: 13px;
    color: var(--text-secondary);
    line-height: 1.5;
    margin: 0;
  }
`;

export const VidalDifferentialsBox = styled.div`
  background: linear-gradient(
    135deg,
    rgba(34, 197, 94, 0.1) 0%,
    rgba(22, 163, 74, 0.05) 100%
  );
  border: 1px solid rgba(34, 197, 94, 0.2);
  border-radius: 24px;
  padding: 40px;

  h3 {
    text-align: center;
    font-size: 1.5rem;
    color: white;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;

    svg { color: var(--vidal-primary); }
  }
`;

export const VidalDifferentialsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const VidalDifferentialItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;

  svg {
    color: var(--vidal-primary);
    font-size: 20px;
    flex-shrink: 0;
    margin-top: 2px;
  }

  strong {
    display: block;
    font-size: 16px;
    color: white;
    margin-bottom: 4px;
  }

  p {
    font-size: 14px;
    color: var(--text-secondary);
    line-height: 1.5;
    margin: 0;
  }

`;

/* Section 6: Next Steps */
export const JourneyTimeline = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
  position: relative;
  margin-bottom: 80px;

  &::before {
    content: '';
    position: absolute;
    top: 40px;
    left: 0;
    width: 100%;
    height: 2px;
    background: linear-gradient(
      90deg,
      rgba(59, 130, 246, 0) 0%,
      rgba(59, 130, 246, 0.3) 15%,
      rgba(59, 130, 246, 0.3) 85%,
      rgba(59, 130, 246, 0) 100%
    );
    z-index: 0;
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    
    &::before {
      display: none;
    }
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const JourneyStep = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
  padding-top: 20px;
`;

export const JourneyStepIcon = styled.div `
  width: 80px;
  height: 80px;
  background: var(--bg-card);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 50%;
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: var(--vidal-blue);
  box-shadow: 0 0 0 8px rgba(15, 23, 42, 1);
  transition: all 0.3s ease;

  ${JourneyStep}:hover & {
    transform: scale(1.1);
    box-shadow: 0 0 0 8px rgba(15, 23, 42, 1), 0 0 20px rgba(59, 130, 246, 0.4);
    background: rgba(59, 130, 246, 0.1);
  }
`;

export const JourneyStepTitle = styled.div`
  font-size: 1.125rem;
  font-weight: 700;
  color: white;
  margin-bottom: 12px;
`;

export const JourneyStepDescription = styled.div`
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.5;
  margin-bottom: 16px;
  min-height: 42px;
`;

export const JourneyStepDuration = styled.div`
  display: inline-block;
  padding: 4px 12px;
  background: rgba(59, 130, 246, 0.1);
  border-radius: 50px;
  font-size: 12px;
  font-weight: 600;
  color: var(--vidal-blue);
`;

export const CtaBox = styled.div`
  background: linear-gradient(
    135deg,
    rgba(37, 99, 235, 0.2) 0%,
    rgba(29, 78, 216, 0.1) 100%
  );
  border: 1px solid rgba(37, 99, 235, 0.3);
  border-radius: 24px;
  padding: 60px;
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(
      circle at top right,
      rgba(59, 130, 246, 0.1),
      transparent 50%
    );
  }

  h3 {
    font-size: 2.5rem;
    font-weight: 800;
    color: white;
    margin-bottom: 16px;
    position: relative;
    z-index: 1;

    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }

  p {
    font-size: 1.25rem;
    color: #e2e8f0;
    margin-bottom: 40px;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    z-index: 1;
  }
`;

export const CtaButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  position: relative;
  z-index: 1;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const BtnCtaPrimary = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 16px 32px;
  background: var(--vidal-primary);
  color: white;
  border-radius: 12px;
  font-size: 1.125rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3);

  &:hover {
    background: var(--vidal-secondary);
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(34, 197, 94, 0.4);
    color: white;
  }

  svg { font-size: 20px; }
`;

export const BtnCtaSecondary = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 16px 32px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  font-size: 1.125rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-2px);
    color: white;
  }

  svg { font-size: 20px; }
`;

/* Footer */
export const Footer = styled.footer`
  background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
  color: white;
  padding: 60px 0 40px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
`;

export const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 60px;

  @media (max-width: 768px) {
    padding: 0 24px;
    flex-direction: column;
    gap: 40px;
  }
`;

export const FooterColumn = styled.div`
  flex: 1;
  min-width: 280px;

  p {
    color: #9ca3af;
    line-height: 1.6;
    margin-bottom: 24px;
    max-width: 350px;
  }
`;

export const FooterBrand = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;

  img {
    height: 48px;
    width: auto;
  }
`;

export const FooterBadge = styled.div`
  background: rgba(34, 197, 94, 0.05);
  border: 1px solid rgba(34, 197, 94, 0.2);
  border-radius: 12px;
  padding: 20px;
  max-width: 350px;

  .badge-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
    color: var(--vidal-primary);
    font-weight: 700;
    font-size: 13px;
    letter-spacing: 0.5px;
    
    svg { font-size: 16px; }
  }

  p {
    color: #e5e7eb; /* Brighter than gray-400 */
    font-size: 13px;
    margin: 0;
    line-height: 1.4;
  }
`;

export const FooterTitle = styled.h4`
  color: white;
  font-size: 1.125rem;
  font-weight: 700;
  margin-bottom: 24px;
  position: relative;
  display: inline-block;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 40px;
    height: 2px;
    background: var(--vidal-primary);
  }
`;

export const FooterContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FooterContactItem = styled.div`
  strong {
    display: block;
    color: white;
    font-size: 14px;
    margin-bottom: 4px;
  }
  
  span {
    color: #9ca3af;
    font-size: 15px;
  }
  
  a {
    color: #9ca3af;
    text-decoration: none;
    transition: color 0.2s;
    
    &:hover {
      color: var(--vidal-primary);
    }
  }
`;

export const FooterBottom = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 40px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 768px) {
    padding: 24px 24px 0;
    justify-content: center;
    text-align: center;
    flex-direction: column;
  }
`;

export const FooterCopyright = styled.div`
  p {
    color: #9ca3af;
    font-size: 16px;
    margin: 0;
  }
  
  span {
    display: block;
    color: #6b7280;
    font-size: 13px;
    margin-top: 4px;
  }
`;

export const FooterLegal = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  
  a {
    color: #9ca3af;
    text-decoration: none;
    font-size: 16px;
    transition: color 0.3s ease;
    
    &:hover {
      color: var(--vidal-primary);
    }
  }
`;







export const FaShoppingCartIcon = styled(FaShoppingCart)``;
export const FaExclamationCircleIcon = styled(FaExclamationCircle)``;
export const FaTimesCircleIcon = styled(FaTimesCircle)``;
export const FaShieldAltIcon = styled(FaShieldAlt)``;
export const FaChartLineIcon = styled(FaChartLine)``;
export const FaClockIcon = styled(FaClock)``;
export const FaExclamationTriangleIcon = styled(FaExclamationTriangle)``;
export const FaChartLineDownIcon = styled(FaSortAmountDown)``; 
export const FaHourglassHalfIcon = styled(FaHourglassHalf)``;
export const FaHandHoldingUsdIcon = styled(FaHandHoldingUsd)``;
export const FaUsersIcon = styled(FaUsers)``;
export const FaTachometerAltIcon = styled(FaTachometerAlt)``;
export const FaBullseyeIcon = styled(FaBullseye)``;

// Section 1 Icons Exports
export const FaRocketIcon = styled(FaRocket)``;
export const FaRobotIcon = styled(FaRobot)``;
export const FaCodeIcon = styled(FaCode)``;
export const FaBrainIcon = styled(FaBrain)``;
export const FaStarIcon = styled(FaStar)``;
export const FaCheckCircleIcon = styled(FaCheckCircle)``;

// Section 3 Icons Exports
export const FaLinkIcon = styled(FaLink)``;
export const FaCheckIcon = styled(FaCheck)``;
export const FaProjectDiagramIcon = styled(FaProjectDiagram)``;
export const FaBoltIcon = styled(FaBolt)``;
export const FaChartBarIcon = styled(FaChartBar)``;
export const FaDollarSignIcon = styled(FaDollarSign)``;
export const FaCheckDoubleIcon = styled(FaCheckDouble)``;

export const FaLightbulbIcon = styled(FaLightbulb)``;

// Section 4 Icons Exports
export const FaSearchIcon = styled(FaSearch)``;
export const FaPencilRulerIcon = styled(FaPencilRuler)``;
export const FaVialIcon = styled(FaVial)``;
export const FaSyncAltIcon = styled(FaSyncAlt)``;
export const FaTasksIcon = styled(FaTasks)``;
export const FaBoxIcon = styled(FaBox)``;

// Section 5 Icons Exports
export const FaPiggyBankIcon = styled(FaPiggyBank)``;
export const FaExpandArrowsAltIcon = styled(FaExpandArrowsAlt)``;
export const FaSmileIcon = styled(FaSmile)``;
export const FaGiftIcon = styled(FaGift)``;
export const FaCogsIcon = styled(FaCogs)``;

// Section 6 Icons Exports
export const FaHandshakeIcon = styled(FaHandshake)``;
export const FaClipboardCheckIcon = styled(FaClipboardCheck)``;
export const FaFileContractIcon = styled(FaFileContract)``;
export const FaArrowRightIcon = styled(FaArrowRight)``;
export const FaCommentsIcon = styled(FaComments)``;
export const FaCalendarCheckIcon = styled(FaCalendarCheck)``;




// Login Components
export const LoginContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0d0f14 0%, #12141a 50%, #0d0f14 100%);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(16, 185, 129, 0.1) 0%, transparent 50%);
    animation: rotate 20s linear infinite;
  }

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const LoginCard = styled.div`
  width: 100%;
  max-width: 420px;
  background: rgba(20, 23, 29, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 48px 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5),
              0 0 100px rgba(16, 185, 129, 0.1);
  backdrop-filter: blur(20px);
  position: relative;
  z-index: 1;
  animation: slideUp 0.5s ease-out;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const LoginHeader = styled.div`
  text-align: center;
  margin-bottom: 40px;
`;

export const Logo = styled.div`
  margin: 0 auto 24px;
  width: 48px;
  height: 48px;
  animation: float 3s ease-in-out infinite;

  @keyframes float {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }
`;

export const LoginTitle = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 8px 0;
  letter-spacing: -0.5px;
`;

export const LoginSubtitle = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  line-height: 1.5;
`;

export const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
  letter-spacing: 0.3px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #ffffff;
  font-size: 15px;
  font-family: inherit;
  transition: all 0.2s ease;

  &::placeholder {
    color: rgba(255, 255, 255, 0.3);
  }

  &:focus {
    outline: none;
    background: rgba(255, 255, 255, 0.08);
    border-color: #10b981;
    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const LoginButton = styled.button`
  width: 100%;
  padding: 14px 24px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  border-radius: 12px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 8px;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(16, 185, 129, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.div`
  padding: 12px 16px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 12px;
  color: #ef4444;
  font-size: 13px;
  text-align: center;
  animation: shake 0.3s ease;

  @keyframes shake {
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-10px); }
    75% { transform: translateX(10px); }
  }
`;
